import {
    PortfolioStrategyType, ExpiryType, StrikeSelectionType, MtmCheckType,
    ExitExecutionDays, ExpiryMonthlyOffsetType, UnderlyingValueTypes, WaitToTradeTypes, LegExitTypes, RangeThresholdTypes, RangeTypes, EntryOnTypes, ReOrderConditionTypes, ExecutionDaysType, OperatorType,
    StrikeOperatorType
} from '../../../../utProto/webApiStrategyEnums_pb';
import { OptionMode, ExchangeId, SecurityType, ProductType } from '../../../../utProto/enums_pb';
import { PriceMethodNew } from '../../../../utProto/webAlertStructureEnums_pb';
import { CURRENCY_LABEL, PERCENT_LABEL } from '@app/_helpers';
import { SquareoffType, UnderlyingType } from '../../../../utProto/webApiStrategyEnums_pb';
import { MoveSLToCostType } from '../../../../utProto/webApiStrategyEnums_pb';
import { PRODUCT_TYPE } from '../strategy-form/strategy.enums';

export const STRATEGY_TYPES_STRING = {
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_CUSTOM]: 'Custom',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_STRADDLE]: 'Short Straddle',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_STRADDLE]: 'Long Straddle',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_STRANGLE]: 'Short Strangle',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_STRANGLE]: 'Long Strangle',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_IRON_CONDOR]: 'Long Iron Condor',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_IRON_CONDOR]: 'Short Iron Condor',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_IRON_BUTTERFLY]: 'Long Iron Butterfly',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_IRON_BUTTERFLY]: 'Short Iron Butterfly',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_CALL_BUTTERFLY]: 'Long Call Butterfly',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_CALL_BUTTERFLY]: 'Short Call Butterfly',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_PUT_BUTTERFLY]: 'Long Put Butterfly',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_PUT_BUTTERFLY]: 'Short Put Butterfly',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_BULL_CALL_SPREAD]: 'Bull Call Spread',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_BULL_PUT_SPREAD]: 'Bull Put Spread',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_BEAR_CALL_SPREAD]: 'Bear Call Spread',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_BEAR_PUT_SPREAD]: 'Bear Put Spread',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_CALL]: 'Long Call',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_CALL]: 'Short Call',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_LONG_PUT]: 'Long Put',
    [PortfolioStrategyType.PORTFOLIOSTRATEGYTYPE_SHORT_PUT]: 'Short Put'
}

export const EXPIRY_WEEKLY_TYPES_STRING = {
    [ExpiryType.EXPIRYTYPE_WEEKLY]: 'Weekly',
    [ExpiryType.EXPIRYTYPE_MONTHLY]: 'Monthly',
    [ExpiryType.EXPIRYTYPE_BASIC]: 'Basic',
}

export const EXPIRY_MONTHLY_TYPES_STRING = {
    [ExpiryType.EXPIRYTYPE_MONTHLY]: 'Monthly',
    [ExpiryType.EXPIRYTYPE_BASIC]: 'Basic',
}

export const EXPIRY_OFFSET_TYPES_STRING = {
    [ExpiryMonthlyOffsetType.EXPIRYMONTHLYOFFSETTYPE_CURRENT]: 'Current',
    [ExpiryMonthlyOffsetType.EXPIRYMONTHLYOFFSETTYPE_NEXT]: 'Next',
    [ExpiryMonthlyOffsetType.EXPIRYMONTHLYOFFSETTYPE_FAR]: 'Far',
}

export const LEG_INSTRUEMENT_TYPE = {
    [OptionMode.OPTIONMODE_CALL]: 'Call Options',
    [OptionMode.OPTIONMODE_PUT]: 'Put Options',
}

export const STRIKE_CRITERIA = {
    [StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_NEAREST]: 'Nearest Price',
    [StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_ABOVE]: 'Price >=',
    [StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_BELOW]: 'Price <=',
    [StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_RANGE]: 'Price Range',
    [StrikeSelectionType.STRIKESELECTIONTYPE_SPOT_PERCENTAGE]: '% of Spot',
    [StrikeSelectionType.STRIKESELECTIONTYPE_STRADDLE_PERCENT]: 'Straddle Price %',
    [StrikeSelectionType.STRIKESELECTIONTYPE_STRADDLE_WIDTH]: 'Straddle Width',
}

export const STRIKE_OPERATOR_TYPE = {
    [StrikeOperatorType.STRIKEOPERATORTYPE_PLUS]: '+',
    [StrikeOperatorType.STRIKEOPERATORTYPE_MINUS]: '-',
}

export const  LEG_INSTRUMENT_TYPE_EQUITY = {
    [OptionMode.OPTIONMODE_PUT]: 'Equity',
}

export const LEG_INSTRUEMENT_TYPE_SUPPORTED = {
    [OptionMode.OPTIONMODE_CALL]: 'Call Options',
    [OptionMode.OPTIONMODE_PUT]: 'Put Options',
    [OptionMode.OPTNMODE_MAX]: 'Future'
}

export const STRIKE_SELECTION_STRING = {
    [StrikeSelectionType.STRIKESELECTIONTYPE_ATM]: 'Strike - ATM',
    [StrikeSelectionType.STRIKESELECTIONTYPE_BASIC]: 'Strike - Basic',
    [StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_NEAREST]: 'Price',
    [StrikeSelectionType.STRIKESELECTIONTYPE_OI]: 'Open Interest'
}

export const EXCHANGE_STRINGS = {
    [ExchangeId.EXCHANGEID_NSEFO]: 'NSEFO',
    [ExchangeId.EXCHANGEID_BSEFO]: 'BSEFO',
    [ExchangeId.EXCHANGEID_NSECM]: 'NSECM',
    [ExchangeId.EXCHANGEID_BSECM]: 'BSECM'
}

export const EXCHANGE_ID_VALUES = {
    NSEFO: ExchangeId.EXCHANGEID_NSEFO,
    BSEFO: ExchangeId.EXCHANGEID_BSEFO,
    NSECM: ExchangeId.EXCHANGEID_NSECM,
    BSECM: ExchangeId.EXCHANGEID_BSECM
}

export const EXCHANGE_STRINGS_FOR_CASH = {
    [ExchangeId.EXCHANGEID_NSEFO]: 'NSECM',
    [ExchangeId.EXCHANGEID_BSEFO]: 'BSECM'
}

export const EXCHANGE_STRINGS_FOR_TECHNICAL_INDICATORS = {
    [ExchangeId.EXCHANGEID_NSEFO]: 'NSECM',
    [ExchangeId.EXCHANGEID_BSEFO]: 'BSECM',
    [ExchangeId.EXCHANGEID_NSECM]: 'NSECM',
    [ExchangeId.EXCHANGEID_BSECM]: 'BSECM'
}

export const CASH_TO_OPTIONS_EXCHANGE = {
    [ExchangeId.EXCHANGEID_NSECM]: 'NSEFO',
    [ExchangeId.EXCHANGEID_BSECM]: 'BSEFO'
}

export const EXCHANGE_STRINGS_FOR_OPTIONS = {
    [ExchangeId.EXCHANGEID_NSEFO]: 'NSEFO',
    [ExchangeId.EXCHANGEID_BSEFO]: 'BSEFO'
}

export const EXCHANGE_STRINGS_FOR_EQUITY = {
    [ExchangeId.EXCHANGEID_NSECM]: 'NSECM',
    [ExchangeId.EXCHANGEID_BSECM]: 'BSECM'
}

export const PROFIT_STRING = {
    [MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE]: `Net P/L (${CURRENCY_LABEL})`,
    [MtmCheckType.MTMCHECKTYPE_NET_PNL_PERCENT]: `Net P/L (${PERCENT_LABEL})`,
    [MtmCheckType.MTMCHECKTYPE_POINTS]: `Points (${CURRENCY_LABEL})`,

}

export const WAITTRADE_STRING = {
    [WaitToTradeTypes.WAITTOTRADETYPES_POINT]: `Points`,
    [WaitToTradeTypes.WAITTOTRADETYPES_PERCENTAGE]: `Percentage`
}

export const RANGE_THRESHOLD_TYPES = {
    [RangeThresholdTypes.RANGETHRESHOLDTYPES_PREMIUM]: `Premium`,
    [RangeThresholdTypes.RANGETHRESHOLDTYPES_UNDERLYING]: `Underlying`
}

export const RANGE_THRESHOLD_TYPES_EQUITY = {
    [RangeThresholdTypes.RANGETHRESHOLDTYPES_PREMIUM]: `Price`
}

export const RANGE_TYPES = {
    [RangeTypes.RANGETYPES_TIME]: `Time`,
    [RangeTypes.RANGETYPES_VALUES]: `Value`
}

export const ENTRY_ON_TYPES = {
    [EntryOnTypes.ENTRYONTYPES_HIGH]: `High`,
    [EntryOnTypes.ENTRYONTYPES_LOW]: `Low`,
    [EntryOnTypes.ENTRYONTYPES_IN_BETWEEN]: `In Between`,
}

export const LEGEXITTYPE_STRING = {
    [LegExitTypes.LEGEXITTYPES_UNDERLYING_POINTS]: `Underlying (pts)`,
    [LegExitTypes.LEGEXITTYPES_DELTA]: `Delta`,
}


export const PORTFOLIO_EXIT_LEGEXITTYPE_STRING = {
    [LegExitTypes.LEGEXITTYPES_UNDERLYING]: `Underlying (₹)`,
    [LegExitTypes.LEGEXITTYPES_UNDERLYING_POINTS]: `Underlying (pts)`,
}

export const PROFIT_STRING_ALL = {
    [MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE]: `Net P/L (${CURRENCY_LABEL})`,
    [MtmCheckType.MTMCHECKTYPE_UNDERLYING]: 'Underlying (₹)',
    [MtmCheckType.MTMCHECKTYPE_UNDERLYING_POINTS]: 'Underlying (pts)',
    [MtmCheckType.MTMCHECKTYPE_DELTA]: 'Delta'
}

export const PROFIT_STRING_STR = {
    [MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE]: `Net P/L (${CURRENCY_LABEL})`
}

export const UNDERLYING_OPTIONS = {
    [UnderlyingType.UNDERLYINGTYPE_CASH]: 'Cash',
    [UnderlyingType.UNDERLYINGTYPE_FUTURE]: 'Future'
}

export const PRODUCT_OPTIONS = {
    [ProductType.PRODUCTTYPE_INTRADAY]: 'Intraday',
    [ProductType.PRODUCTTYPE_CARRYFORWARD]: 'Carryforward'
}

export const PRODUCT_OPTIONS_INTRADAY_ONLY = {
    [ProductType.PRODUCTTYPE_INTRADAY]: 'Intraday'
}

export const PRODUCT_OPTIONS_CARRYFORWARD_ONLY = {
    [ProductType.PRODUCTTYPE_CARRYFORWARD]: 'Carryforward'
}

export const SQUAREOFF_OPTIONS = {
    [SquareoffType.SQUAREOFFTYPE_PARTIAL]: 'Partial',
    [SquareoffType.SQUAREOFFTYPE_COMPLETE]: 'Complete'
}

export const MOVE_SL_TO_COST_OPTIONS = {
    [MoveSLToCostType.MOVESLTOCOSTTYPE_ALL_LEGS]: 'All Legs',
    [MoveSLToCostType.MOVESLTOCOSTTYPE_SL_LEGS]: 'SL Legs'
}

export const LEG_SHORT_INSTRUMENT_TYPE = {
    [OptionMode.OPTIONMODE_CALL]: 'CE',
    [OptionMode.OPTIONMODE_PUT]: 'PE',
}

export const RE_ORDER_CONDITION_TYPE_LEG = {
    [ReOrderConditionTypes.REORDERCONDITIONTYPES_RE_EXECUTION]: 'Re-Execution',
    [ReOrderConditionTypes.REORDERCONDITIONTYPES_RE_ENTRY]: 'Re-Entry',
    [ReOrderConditionTypes.REORDERCONDITIONTYPES_DEPENDENT]: 'Dependent Leg'
}

export const RE_ORDER_CONDITION_TYPE_LEG_PRICE = {
    [ReOrderConditionTypes.REORDERCONDITIONTYPES_RE_EXECUTION]: 'Re-Execution',
    [ReOrderConditionTypes.REORDERCONDITIONTYPES_DEPENDENT]: 'Dependent Leg'
}


export const RE_ORDER_CONDITION_TYPE_EXIT = {
    [ReOrderConditionTypes.REORDERCONDITIONTYPES_RE_EXECUTION]: 'Re-Execution'
}

export const STRIKE_PRICE_SEARCH_FILTER = {
    [StrikeSelectionType.STRIKESELECTIONTYPE_ATM]: 'ATM',
    [StrikeSelectionType.STRIKESELECTIONTYPE_BASIC]: 'basic'
}

export const EXIT_PRICE_METHOD_STRING = {
    [PriceMethodNew.PRICEMETHODNEW_MARKET]: 'Market Order',
    // RA-2063 LTP removed for now as not handled at HFT
    // [PriceMethodNew.PRICEMETHODNEW_LTP]: 'LTP'
}

export const EXIT_EXECUTION_DAYS_VALUES = {
    [ExitExecutionDays.EXITEXECUTIONDAYS_ALL]: 'All',
    [ExitExecutionDays.EXITEXECUTIONDAYS_MONDAY]: 'Mon',
    [ExitExecutionDays.EXITEXECUTIONDAYS_TUESDAY]: 'Tue',
    [ExitExecutionDays.EXITEXECUTIONDAYS_WEDDAY]: 'Wed',
    [ExitExecutionDays.EXITEXECUTIONDAYS_THURSDAY]: 'Thur',
    [ExitExecutionDays.EXITEXECUTIONDAYS_FRIDAY]: 'Fri'
}

export const WEEK_DAYS_ENUM = {
    'All': ExitExecutionDays.EXITEXECUTIONDAYS_ALL.toString(),
    'Mon': ExitExecutionDays.EXITEXECUTIONDAYS_MONDAY.toString(),
    'Tue': ExitExecutionDays.EXITEXECUTIONDAYS_TUESDAY.toString(),
    'Wed': ExitExecutionDays.EXITEXECUTIONDAYS_WEDDAY.toString(),
    'Thur': ExitExecutionDays.EXITEXECUTIONDAYS_THURSDAY.toString(),
    'Fri': ExitExecutionDays.EXITEXECUTIONDAYS_FRIDAY.toString(),
}

export enum ExitParamTypes {
    strategy = 'strategy',
    portfolio = 'portfolio',
    details = 'details'
}

export enum NAME_STRING {
    STRATEGY = 'Strategy',
    PORTFOLIO = 'Portfolio'
}

export const UNDERLYING_TYPES = {
    [UnderlyingValueTypes.UNDERLYINGVALUETYPES_TARGET_PROFIT]: 'TP',
    [UnderlyingValueTypes.UNDERLYINGVALUETYPES_STOP_LOSS]: 'SL',
}

export const OPTION_MODE_TO_INSTRUMENT = {
    [OptionMode.OPTIONMODE_CALL]: SecurityType.SECURITYTYPE_OPTION,
    [OptionMode.OPTIONMODE_PUT]: SecurityType.SECURITYTYPE_OPTION,
    [OptionMode.OPTNMODE_MAX]: SecurityType.SECURITYTYPE_FUTURE,
}

export const EXECUTION_ON_TYPES = {
    [ExecutionDaysType.EXECUTIONDAYSTYPE_WEEK_DAYS]: 'Days',
    [ExecutionDaysType.EXECUTIONDAYSTYPE_RANGE_BASED]: 'Days To Expiry'
}

export const EXECUTION_ON_DAYS = {
    [ExecutionDaysType.EXECUTIONDAYSTYPE_WEEK_DAYS]: 'Days'
}

export const COMPARATORS_STRING = {
    [OperatorType.LESS_THAN]: '<',
    [OperatorType.LESS_THAN_EQUAL]: '<=',
    [OperatorType.EQUAL_TO]: '=',
    [OperatorType.GREATER_THAN_EQUAL]: '>=',
    [OperatorType.GREATER_THAN]: '>'
}

export enum PortfolioCreationType {
    New = 0,
    Copy = 1,
    ExitAlreadySaved = 2,
    Shared = 3
}
